import React, { useState, useEffect } from 'react';
import './AdminProfile.css'; // Uses the same final CSS file

const getInitials = (name = '') => {
  if (!name) return 'A';
  const words = name.split(' ');
  return (words[0][0] + (words.length > 1 ? words[words.length - 1][0] : '')).toUpperCase();
};

const PasswordStrengthMeter = ({ strength }) => (
  <div className="password-strength-meter">
    <div className={`strength-bar ${strength > 0 ? 'filled weak' : ''}`}></div>
    <div className={`strength-bar ${strength > 1 ? 'filled medium' : ''}`}></div>
    <div className={`strength-bar ${strength > 2 ? 'filled strong' : ''}`}></div>
  </div>
);

const AdminProfile = () => {
  const [profile, setProfile] = useState({
    name: 'Admin User',
    email: 'admin@whiteoak.com',
    phone: '123-456-7890',
  });
  // CORRECTED: State now uses 'confirmPassword'
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '' // The correct third field
  });
  
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmittingProfile, setIsSubmittingProfile] = useState(false);
  const [isSubmittingPassword, setIsSubmittingPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);

  useEffect(() => {
    let score = 0;
    const pass = passwordData.newPassword;
    if (pass.length > 7) score++;
    if (pass.match(/[A-Z]/) && pass.match(/[a-z]/)) score++;
    if (pass.match(/[0-9]/) || pass.match(/[^A-Za-z0-9]/)) score++;
    setPasswordStrength(score);
  }, [passwordData.newPassword]);

  const handleInputChange = (e) => setProfile({ ...profile, [e.target.name]: e.target.value });
  const handlePasswordChange = (e) => setPasswordData({ ...passwordData, [e.target.name]: e.target.value });

  const handleProfileUpdate = (e) => {
    e.preventDefault();
    setIsSubmittingProfile(true);
    setError(''); setSuccess('');
    setTimeout(() => {
      setIsSubmittingProfile(false);
      setSuccess('Profile details updated successfully!');
      setIsEditing(false);
    }, 1200);
  };

  const handlePasswordUpdate = (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    
    // CORRECTED: Validation now checks 'confirmPassword'
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setError("The new passwords do not match. Please try again.");
      return;
    }
    
    setIsSubmittingPassword(true);
    setTimeout(() => {
      setIsSubmittingPassword(false);
      setSuccess('Password changed successfully!');
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    }, 1200);
  };

  return (
    <div className="profile-container">
      <header className="page-header-profile">
        <div className="page-header-info">
          <div className="avatar-large">{getInitials(profile.name)}</div>
          <div className="profile-info">
            <h1 className="profile-name-header">{profile.name}</h1>
            <span className="profile-role">Administrator</span>
          </div>
        </div>
      </header>

      {error && <div className="banner error-banner" onClick={() => setError('')}><i className="bi bi-exclamation-triangle-fill"></i>{error}</div>}
      {success && <div className="banner success-banner" onClick={() => setSuccess('')}><i className="bi bi-check-circle-fill"></i>{success}</div>}

      <div className="profile-content-grid">
        {/* Profile Details Card (Unchanged) */}
        <form className="profile-card" onSubmit={handleProfileUpdate}>
          {/* ... same as before ... */}
          <header className="card-header"><h2>Account Details</h2>{!isEditing && <button type="button" className="btn-edit" onClick={() => setIsEditing(true)}>Edit</button>}</header>
          <div className="card-body">
            <div className="form-row"><label>Full Name</label><div className="input-wrapper"><i className="bi bi-person"></i>{isEditing ? <input name="name" type="text" value={profile.name} onChange={handleInputChange} required /> : <p className="view-mode-text">{profile.name}</p>}</div></div>
            <div className="form-row"><label>Email Address</label><div className="input-wrapper"><i className="bi bi-envelope"></i>{isEditing ? <input name="email" type="email" value={profile.email} onChange={handleInputChange} required /> : <p className="view-mode-text">{profile.email}</p>}</div></div>
            <div className="form-row"><label>Phone Number</label><div className="input-wrapper"><i className="bi bi-telephone"></i>{isEditing ? <input name="phone" type="tel" value={profile.phone || ''} onChange={handleInputChange} /> : <p className="view-mode-text">{profile.phone || 'Not provided'}</p>}</div></div>
          </div>
          {isEditing && (<footer className="card-footer"><button type="button" className="btn-cancel" onClick={() => setIsEditing(false)} disabled={isSubmittingProfile}>Cancel</button><button type="submit" className="btn-save" disabled={isSubmittingProfile}>{isSubmittingProfile ? <><span className="spinner"></span> Saving...</> : 'Save Changes'}</button></footer>)}
        </form>

        {/* Change Password Card (CORRECTED) */}
        <form className="profile-card" onSubmit={handlePasswordUpdate}>
          <header className="card-header">
            <h2>Change Password</h2>
          </header>
          <div className="card-body">
            {/* Field 1: Current Password */}
            <div className="form-row">
              <label>Current Password</label>
              <div className="input-wrapper"><i className="bi bi-shield-lock"></i><input name="currentPassword" type="password" value={passwordData.currentPassword} onChange={handlePasswordChange} required /></div>
            </div>
            
            {/* Field 2: New Password */}
            <div className="form-row">
              <label>New Password</label>
              <div className="input-wrapper"><i className="bi bi-key"></i><input name="newPassword" type="password" value={passwordData.newPassword} onChange={handlePasswordChange} required minLength="8" /></div>
            </div>
            {passwordData.newPassword && <PasswordStrengthMeter strength={passwordStrength} />}

            {/* Field 3: Confirm New Password (CORRECTED) */}
            <div className="form-row">
              <label>Confirm New Password</label>
              <div className="input-wrapper"><i className="bi bi-key-fill"></i><input name="confirmPassword" type="password" value={passwordData.confirmPassword} onChange={handlePasswordChange} required /></div>
            </div>
          </div>
          <footer className="card-footer">
            <button type="submit" className="btn-save" disabled={isSubmittingPassword}>
              {isSubmittingPassword ? <><span className="spinner"></span> Updating...</> : 'Update Password'}
            </button>
          </footer>
        </form>
      </div>
    </div>
  );
};

export default AdminProfile;